import type { FieldInputProps } from '../types'

export function BooleanInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <input
      type="checkbox"
      id={`field-${field.fieldCode}`}
      checked={!!value}
      disabled={disabled}
      onChange={e => onChange(e.target.checked)}
    />
  )
}
